import { DETALHE_PAGAMENTO, PAGAMENTO, PagamentoActionTypes, PagamentoState } from 'domain/types/_carteira/detalhePagamento/detalhePagamento';
import { DetalhePagamentoResponse } from '../../../types/detalheResgate/detalhePagamentoResponse';

const INITIAL_STATE: PagamentoState = {
  Pagamento: [],
  PagamentoDetalhe: []
};

export function PagamentoReducer(
  state = INITIAL_STATE,
  action: PagamentoActionTypes
): PagamentoState {
  switch (action.type) {
    case PAGAMENTO:
      return { ...state, Pagamento: action.payload as [] };
    case DETALHE_PAGAMENTO: {
      const payload = action.payload;
      const normalized = Array.isArray(payload) ? payload : [payload];
      return { ...state, PagamentoDetalhe: normalized as DetalhePagamentoResponse[] };
    }
    default:
      return state;
  }
}